(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshowtwo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('slideshow-banner-component')) return;

    class SlideshowBannerComponent extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.slideshow-banner__track');
        this.slides = Array.from(this.querySelectorAll('.slideshow-banner__slide'));
        this.prevBtn = this.querySelector('.slideshow-banner__nav--prev');
        this.nextBtn = this.querySelector('.slideshow-banner__nav--next');
        this.dots = Array.from(this.querySelectorAll('.slideshow-banner__dot'));
        this.index = 0;
        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = (parseFloat(this.dataset.speed) || 5) * 1000;
        this.timer = null;

        if (this.slides.length <= 1) return;

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.play());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.play());

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stop();
          else this.play();
        });

        this.render();
        this.play();
      }

      disconnectedCallback() {
        this.stop();
      }

      go(newIndex) {
        const count = this.slides.length;
        this.index = (newIndex + count) % count;
        this.render();
      }

      render() {
        this.track.style.transform = `translateX(-${this.index * 100}%)`;
        this.slides.forEach((slide, i) => {
          const isActive = i === this.index;
          slide.setAttribute('aria-hidden', String(!isActive));
          const link = slide.querySelector('.slideshow-banner__media-link');
          if (link) link.setAttribute('tabindex', isActive ? '0' : '-1');
        });
        this.dots.forEach((dot, i) => {
          dot.setAttribute('aria-current', String(i === this.index));
        });
      }

      play() {
        if (!this.autoplay) return;
        this.stop();
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion) return;
        this.timer = setInterval(() => this.go(this.index + 1), this.speed);
      }

      stop() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    }

    customElements.define('slideshow-banner-component', SlideshowBannerComponent);
  })();

  } catch(e) { console.error(e); }
})();
})();
